__turbopack_context__.v({
  "className": "inter_6124bc47-module__OmQ10a__className",
});
